import FooterDesktopPokerstars from 'images/background/bg-footer-banner-desktop-pokerstars.jpg';
import FooterMobilePokerstars from 'images/background/bg-footer-banner-mobile-pokerstars.jpg';

export const FooterTheme = {
  footer: {
    container: {
      selfMarginHandling: true,
      width: '100%',
      borderRadius: '8px',
      mobile: {
        backgroundImage: `url(${FooterMobilePokerstars})`,
      },
      desktop: {
        backgroundImage: `url(${FooterDesktopPokerstars})`,
      },
      title: {
        fontSize: '20px',
        fontWeight: '800',
        lineHeight: '25.1px',
        marginTop: '0',
        marginBottom: '4px',
      },
      subtitle: {
        fontSize: '14px',
        fontWeight: '400',
        lineHeight: '18px',
        marginTop: '0',
        marginBottom: '32px',
      },
      button: {
        borderRadius: '8px',
        width: '149px',
      },
    },
  },
};
